export enum TmsEvent {
    LINK = 'link',
    VIEW = 'view',
}
